import React from "react";
import { motion } from "framer-motion";
import {
  Award,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
const About = () => {
  return (
    <div className="w-full bg-[#F6F8FC] overflow-hidden">
      <section className="w-full py-10 md:py-12">
        <div className="w-full px-6 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-12 gap-8 items-center">
              <motion.div
                initial={{ opacity: 0, x: -35 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.65 }}
                viewport={{ once: true }}
                className="lg:col-span-7"
              >
                <div className="bg-white rounded-[26px] shadow-xl border border-gray-100 p-6 md:p-8">
                  <span className="text-[#D4A017] text-sm font-black uppercase tracking-wide">
                    Welcome To Pt. Shrinivas Dwivedi Mahavidyalaya
                  </span>
                  <h2 className="text-2xl md:text-4xl font-black text-[#071A52] mt-3 mb-5 leading-tight">
                    Building Knowledge, Discipline & Future
                  </h2>
                  <p className="text-gray-700 leading-relaxed text-sm md:text-base mb-4">
                    Pt. Shrinivas Dwivedi Mahavidyalaya is a reputed educational
                    institution located at Arangi, District Chandauli, Uttar
                    Pradesh. The college is committed to providing quality
                    higher education with discipline, values, and overall
                    student development.
                  </p>
                  <p className="text-gray-700 leading-relaxed text-sm md:text-base mb-6">
                    The institution focuses on academic excellence and helps
                    students build confidence, knowledge, and a strong academic
                    foundation for their future.
                  </p>
                  <div className="rounded-2xl bg-[#071A52] p-5 md:p-6 text-white">
                    <h3 className="text-lg font-black mb-4 text-[#FFD700]">
                      College Details
                    </h3>
                    <div className="grid md:grid-cols-2 gap-4 text-sm">
                      <p className="flex gap-3">
                        <MapPin
                          size={18}
                          className="text-[#FFD700] shrink-0 mt-0.5"
                        />
                        <span>
                          Village & Post Arangi, District Chandauli, Uttar
                          Pradesh - 232110
                        </span>
                      </p>
                      <p className="flex gap-3">
                        <Award
                          size={18}
                          className="text-[#FFD700] shrink-0 mt-0.5"
                        />
                        <span>
                          Affiliated To: Mahatma Gandhi Kashi Vidyapith,
                          Varanasi
                        </span>
                      </p>
                      <p className="flex gap-3">
                        <Mail
                          size={18}
                          className="text-[#FFD700] shrink-0 mt-0.5"
                        />
                        <span>psndwivedi@gmail.com</span>
                      </p>
                      <p className="flex gap-3">
                        <Phone
                          size={18}
                          className="text-[#FFD700] shrink-0 mt-0.5"
                        />
                        <span>+91-9451887217, +91-9450181867</span>
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, x: 35 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.65 }}
                viewport={{ once: true }}
                className="lg:col-span-5 relative"
              >
                <div className="absolute -top-5 -right-5 w-28 h-28 bg-[#FFD700] rounded-full blur-2xl opacity-40"></div>
                <div className="absolute -bottom-5 -left-5 w-28 h-28 bg-[#071A52] rounded-full blur-2xl opacity-20"></div>
                <div className="relative bg-white rounded-[28px] shadow-2xl overflow-hidden border border-gray-100">
                  <div className="relative">
                    <img
                      src="/image1.png"
                      alt="Pt. Shrinivas Dwivedi Mahavidyalaya"
                      className="w-full h-[300px] md:h-[420px] object-cover"
                    />

                    <div className="absolute inset-0 bg-gradient-to-t from-[#071A52]/70 via-transparent to-transparent"></div>
                    <div className="absolute bottom-5 left-5 right-5 bg-white/90 backdrop-blur-md rounded-2xl p-4 shadow-lg">
                      <h3 className="text-lg md:text-xl font-black text-[#071A52]">
                        Pt. Shrinivas Dwivedi Mahavidyalaya
                      </h3>
                      <p className="text-sm text-gray-700 mt-1 font-medium">
                        Arangi, Chandauli, Uttar Pradesh
                      </p>
                    </div>
                  </div>
                </div>
                <div className="hidden md:block absolute -z-10 -bottom-5 -right-5 w-full h-full bg-[#FFD700] rounded-[28px]"></div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default About;